import cardValidator from 'card-validator'

export class BaseServices {
    constructor () {
      if (new.target === BaseServices) {
        throw new TypeError('Cannot construct BaseServices instances directly')
      }
    }

    validateNumber (cardNumber) {
        throw new Error('Abstract method validateCardNumber not implemented')
    }

    getCardBrand (cardNumber) {
        throw new Error('Abstract method getCardBrand not implemented')
    }

    validateSecurityCode (securityCode, maxLength) {
        return cardValidator.cvv(securityCode, maxLength).isValid
    }
    
    validateExpirationDate (month, year) {
        return cardValidator.expirationDate({ month: month, year: year }).isValid
    }
}
  